import { Quote } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const STORIES = [
  {
    quote: "Twelve hundred onboarding kits across four cities, and not a single missed deadline. New joiners were posting their boxes before day one ended.",
    name: "Ananya Rao",
    role: "Head of People, Series-C fintech",
    stat: "1,200 kits · 4 cities",
  },
  {
    quote: "Our guests still talk about the favours. Gratiora matched the wax seals to the wedding palette — nobody else we asked would even try.",
    name: "Kabir & Sana Mehta",
    role: "Wedding, Jaipur · 300 favours",
    stat: "300 favours · 3 palette iterations",
  },
  {
    quote: "We briefed them on a Tuesday and had a photographed sample with our logo by Friday. Procurement signed off in one meeting.",
    name: "Rohan Iyer",
    role: "Brand Lead, consumer goods major",
    stat: "Sample in 3 days · 5,000-unit run",
  },
];

export default function Testimonials() {
  return (
    <section id="stories" className="py-20 lg:py-32 px-6 lg:px-12 max-w-7xl mx-auto">
      <Reveal>
        <p className="eyebrow">Client Stories</p>
        <h2 className="mt-4 font-serif text-2xl sm:text-3xl lg:text-4xl text-ink tracking-tight text-balance">
          Trusted with the moments that matter
        </h2>
      </Reveal>
      <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
        {STORIES.map((s, i) => (
          <Reveal key={s.name} delay={i * 0.1}>
            <figure
              data-testid={`client-story-${i}`}
              className="h-full flex flex-col bg-white border border-gold/15 p-8 hover:border-gold/40 hover:shadow-[0_20px_40px_rgba(212,175,55,0.08)] transition-[border-color,box-shadow] duration-500"
            >
              <Quote size={22} strokeWidth={1.5} className="text-gold-brass" />
              <blockquote className="mt-5 font-serif text-lg leading-relaxed text-ink flex-1">
                “{s.quote}”
              </blockquote>
              <figcaption className="mt-6 pt-5 border-t border-gold/15">
                <p className="text-sm font-medium text-ink">{s.name}</p>
                <p className="mt-0.5 text-xs text-ink-muted">{s.role}</p>
                <p className="mt-3 font-mono text-[10px] uppercase tracking-[0.15em] text-gold-brass">{s.stat}</p>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
